const config = { ...(global.__STATIC_CONFIG__ || {}) } as App.AppConfig

export const setConfig = newConfig => {
  Object.assign(config, newConfig)
  return config
}

export default config
